/* cSpell:disable */
export enum Module {
  SALES = 'CMSA',
  CAMPAIGNS = 'CMCP',
  ADMIN = 'ADMN',
  SHOW_CASE_PRO = 'SCSP',
  SHOW_CASE_LITE = 'SCSL',
  CRM = 'CMRM',
  SITE = 'SITE',
  OPS = 'COPS',
  SPACE = 'SPCE'
}
export enum Feature {
  ACCOUNT_SETTINGS = 'ACST',
  PROJECT_CONFIGURATION = 'PRCG',
  SETTINGS = 'STNG',
  LEAD = 'CMLD',
  SITEVISIT = 'CMSV',
  TASK = 'CMTK',
  SHOW_CASE_PRO = 'SCSP',
  SHOW_CASE_LITE = 'SCSL',
  CUSTOMERS = 'CTMR',
  CAMPAIGNS = 'CMPN',
  PAYMENTS = 'PYMT',
  INVENTORY = 'IVTY',
  SALES_REPORTS = 'SARP',
  CHANNEL_PARTNER_REPORTS = 'CPRP',
  MARKETING_REPORTS = 'MRRP',
  SITE_DOCUMENTS = 'SIDC',
  AUDIT_REPORT = 'ARRP',
  CRM_REPORTS = 'CRMR',
  SAPCE_DASHBOARD = 'SPDB',
  ENABLE_AI_ASSISTANT = 'EAA'
}

export enum ShowCaseLiteMask {
  View = 1,
  EXPORT = 2
}

export enum ShowCaseProMask {
  View = 1,
  EXPORT = 2
}

export enum LeadFeaturePermission {
  View = 'LDVW',
  Create = 'LDCR',
  Modify = 'LDMD',
  Delete = 'LDDL',
  IMPORT = 'LDIM',
  EXPORT = 'LDEX',
  ACTIONS = 'LDAS',
  ChannelPartner = 'LDCP',
  TemporaryLeadTransfer = 'TLTR',
  UnMasking = 'LDUM',
  ChannelPartnerLeadRequest = 'LDRQ',
  TransferLeads = 'TL'
}
export enum LeadFeaturePermissionMask {
  View = 1,
  Create = 2,
  Modify = 4,
  Delete = 8,
  IMPORT = 16,
  EXPORT = 32,
  ACTIONS = 64,
  ChannelPartner = 128,
  TemporaryLeadTransfer = 256,
  UnMasking = 512,
  ChannelPartnerLeadRequest = 1024,
  TransferLeads = 2048
}

export enum CampaignsPermission {
  View = 'CMPV',
  Create = 'CMPC',
  Modify = 'CMPM',
  Delete = 'CMPD'
}

export enum CampaignsPermissionMask {
  View = 1,
  Create = 2,
  Modify = 4,
  Delete = 8
}

export enum CustomersPermission {
  View = 'CTRV',
  Create = 'CTRC',
  Modify = 'CTRM',
  customerdocuments = 'CDOC',
  CancelUnit = 'CUNT',
  AgreementForSale = 'CTAS',
  ProvisionalAllotment = 'CTPT',
  UnitCustomizationRequest = 'CTUC',
  UnitCustomizationApproval = 'CTCA',
  CommissionApproval = 'CTCM',
  MilestoneApproval = 'CTMA',
  CancelAllotment = 'CPCA'
}

export enum CustomersPermissionMask {
  View = 1,
  Create = 2,
  Modify = 4,
  CustomerDocuments = 8,
  CancelUnit = 16,
  AgreementForSale = 32,
  ProvisionalAllotment = 64,
  Import = 128,
  UnitCustomizationRequest = 256,
  UnitCustomizationApproval = 512,
  CommissionApproval = 1024,
  MilestoneApproval = 2048,
  CancelAllotment = 4096
}

export enum SettingFeaturePermission {
  LEAD_PRIORITY = 'LDPT',
  LEAD_BUCKET = 'LBKT',
  LEAD_PIPELINE = 'LPLE',
  LEAD_FEEDBACK = 'LFBK',
  LEAD_SOURCE = 'LSRC',
  LEAD_ASSIGNMENT = 'LASG',
  LEAD_INTEGRATIONS = 'LINT',
  FORM_PROPERTIES = 'FPRP',
  LEAD_SUB_SOURCE = 'LSSC',
  SR_NUMBER = 'LSRN',
  LEAD_WORK_FLOWS = 'LWKF',
  AdDS_ACCOUNTS = 'CAAC',
  CUSTOMER_WORK_FLOWS = 'CWKF',
  EXECUTIVES = 'CEXC',
  PAYMENT_REJECTION_REASON = 'PTRR',
  TEMPLATES = 'CTMP',
  CUSTOMER_SOURCE = 'CSRC',
  GENERAL_SETTINGS = 'GSTG',
  CUSTOMER_DEMAND_LETTERS = 'CDLR',
  NUMBER_FORMATS = 'NOFT',
  INVENTORY_ACCESS = 'INAS',
  DRAWING_STAGES = 'DWSG',
  DRAWING_TYPES = 'DWTP',
}
export enum SettingFeaturePermissionMask {
  LEAD_PRIORITY = 1,
  LEAD_BUCKET = 2,
  LEAD_PIPELINE = 4,
  LEAD_FEEDBACK = 8,
  LEAD_SOURCE = 16,
  LEAD_ASSIGNMENT = 32,
  LEAD_INTEGRATIONS = 64,
  FORM_PROPERTIES = 128,
  LEAD_SUB_SOURCE = 256,
  SR_NUMBER = 512,
  LEAD_WORK_FLOWS = 1024,
  AdDS_ACCOUNTS = 2048,
  CUSTOMER_WORK_FLOWS = 4096,
  EXECUTIVES = 8192,
  PAYMENT_REJECTION_REASON = 16384,
  TEMPLATES = 32768,
  CUSTOMER_SOURCE = 65536,
  GENERAL_SETTINGS = 131072,
  CUSTOMER_DEMAND_LETTERS = 262144,
  NUMBER_FORMATS = 524288,
  INVENTORY_ACCESS = 1048576,
  DRAWING_STAGES = 2097152,
  DRAWING_TYPES = 4194304
}

export enum AccountSettingFeaturePermission {
  ACCOUNT_INFO = 'ACIN',
  PRODUCT_AND_SERVICES = 'PRSR',
  BILLING = 'BLNG',
  PAYMENT_METHOD = 'PYMT',
  USER_AND_ACCESS = 'USAC',
  NOTIFICATION_SETTINGS = 'NTST',
  CHANNEL_PARTNER = 'CNLP',
  COMMUNICATIONS = 'CMCN'
}
export enum AccountSettingFeaturePermissionMask {
  ACCOUNT_INFO = 1,
  PRODUCT_AND_SERVICES = 2,
  BILLING = 4,
  PAYMENT_METHOD = 8,
  USER_AND_ACCESS = 16,
  NOTIFICATION_SETTINGS = 32,
  CHANNEL_PARTNER = 64,
  COMMUNICATIONS = 128
}
export enum ProjectConfigurationFeaturePermission {
  OVERVIEW = 'ORVW',
  FLOOR_PLAN = 'FLPN',
  PRICING = 'PRCG',
  GALLERY = 'GLRY',
  AMENITIES = 'AMNT',
  SPECIFICATIONS = 'SCFS',
  MODEL_APARTMENT = 'MAPT',
  DOCUMENTS = 'DCMT',
  TERMS_AND_CONDITIONS = 'TCDS',
  UNIT_CUSTOMIZATIONS = 'UCTM'
}
export enum ProjectConfigurationFeaturePermissionMask {
  OVERVIEW = 1,
  PRICING = 2,
  FLOOR_PLAN = 4,
  GALLERY = 8,
  AMENITIES = 16,
  SPECIFICATIONS = 32,
  MODEL_APARTMENT = 64,
  DOCUMENTS = 128,
  TERMS_AND_CONDITIONS = 256,
  UNIT_CUSTOMIZATIONS = 512
}

export enum SiteVisitFeaturePermissionCode {
  View = 'SVVW',
  Create = 'SVCR',
  Modify = 'SVMD',
  AssignTo = 'SASN'
}

export enum SalesReport {
  Sales_Lead_Snapshot = 'SALS',
  Sales_Performance = 'SAPR',
  Sales_SiteVisit_Performance = 'SASP',
  Sales_Daily_Activity = 'SADA',
  Sales_Call_OutBound = 'SACO',
  Sales_Call_Queue = 'SACQ',
  Sales_Stage_Snapshot = 'SASS',
  Sales_Channel_Partner_Walk_In = 'SAWK',
  Sales_Daily_Sales_Activity = 'SADS',
  Sales_Lead_Delete_Log = 'LEDL',
  Sales_Lead_Download_Log ='SLDL'
}

export enum ChannelPartnerReport {
  CP_Lead_Snapshot = 'CPLS',
  CP_Performance = 'CPPR',
  CP_SiteVisit_Performance = 'CPSP',
  CP_Daily_Activity = 'CPDA',
  CP_Call_OutBound = 'CPCO',
  CP_Call_Queue = 'CPCQ',
  CP_Stage_Snapshot = 'CPSS',
  Channel_Partner_Walk_In = 'CPWK',
  CP_Daily_Sales_Activity = 'CPDS'
}

export enum MarketingReport {
  Facebook_Leads_Snapshot = 'FBLS'
}

export enum SiteVisitFeaturePermissionMask {
  View = 1,
  Create = 2,
  Modify = 4,
  AssignTo = 8
}

export enum TaskFeaturePermissionCode {
  View = 'TKVW',
  Create = 'TKCR',
  Modify = 'TKMD',
  AssignTo = 'TASN'
}

export enum TaskFeaturePermissionMask {
  View = 1,
  Create = 2,
  Modify = 4,
  AssignTo = 8
}

export enum PaymentsPermissionCode {
  PaymentDetails = 'PDTL',
  PaymentsApprovalsAndHistory = 'PAHR',
  Download = 'PAHD',
  PayNow = 'PNOW',
  CashTransactions = 'CTRN'
}
export enum PaymentsPermissionMask {
  PaymentDetails = 1,
  PaymentsApprovalsAndHistory = 2,
  Download = 4,
  PayNow = 8,
  CashTransactions = 16
}

export enum CRMReportsPermissionMask {
  Inventory = 1,
  MilestoneDetails = 2,
  PaymentDetails = 4,
  CustomizationDetails = 8,
  EntityInventory = 16
}

export enum InventoryPermissionCode {
  View = 'PUVW',
  CancelUnitReservation = 'CURN'
}

export enum InventoryFeaturePermissionMask {
  View = 1,
  CancelUnitReservation = 2
}

export enum SalesReportsPermissionCode {
  Sales_Lead_Snapshot = 'SALS',
  Sales_Performance = 'SAPR',
  Sales_SiteVisit_Performance = 'SASP',
  Sales_Daily_Activity = 'SADA',
  Sales_Call_OutBound = 'SACO',
  Sales_Call_Queue = 'SACQ',
  Sales_Stage_Snapshot = 'SASS',
  Sales_Channel_Partner_Walk_In = 'SAWK',
  Sales_Daily_Sales_Activity = 'SADS',
  Sales_Call_In_Bound = 'SACI',
  Sales_Lead_Delete_Log = 'LEDL',
  Sales_Lead_Download_Log = 'SLDL'
}

export enum ChannelPartnerReportsPermissionCode {
  CP_Lead_Snapshot = 'CPLS',
  CP_Performance = 'CPPR',
  CP_Daily_Activity = 'CPDA',
  CP_Call_OutBound = 'CPCO',
  CP_Call_Queue = 'CPCQ',
  CP_Stage_Snapshot = 'CPSS',
  Channel_Partner_Walk_In = 'CPWK',
  CP_Daily_Sales_Activity = 'CPDS',
  CP_Call_In_Bound = 'CPCI'
}

export enum MarketingReportsPermissionCode {
  Facebook_Leads_Snapshot = 'FBLS'
}

export enum AuditReportsPermission {
  Audit_Report = 'ARRP'
}

export enum AuditReportsPermissionMask {
  Audit_Report = 1
}

export enum AIAssistantPermission {
  Enable_AIAssistant = 'EAA'
}

export enum AIAssistantPermissionMask {
  Enable_AIAssistant = 1
}

export enum SalesReportsFeaturePermissionMask {
  Sales_Lead_Snapshot = 1,
  Sales_Performance = 2,
  Sales_SiteVisit_Performance = 4,
  Sales_Daily_Activity = 8,
  Sales_Call_OutBound = 16,
  Sales_Call_Queue = 32,
  Sales_Stage_Snapshot = 64,
  Sales_Daily_Sales_Activity = 128,
  Sales_Call_In_Bound = 256,
  Sales_Lead_Delete_Log = 512,
  Sales_Lead_Download_Log = 1024
}

export enum ChannelPartnerReportsFeaturePermissionMask {
  CP_Lead_Snapshot = 1,
  CP_Daily_Activity = 2,
  CP_Call_In_Bound = 4,
  CP_Call_OutBound = 8,
  CP_Call_Queue = 16,
  CP_Stage_Snapshot = 32,
  Channel_Partner_Walk_In = 64,
  CP_Daily_Sales_Activity = 128,
  CP_SiteVisit_Performance = 256
}
export enum MarketingReportsFeaturePermissionMask {
  Facebook_Leads_Snapshot = 1
}

export enum DocumentsFeaturePermissionCode {
  SiteDocumentRequest = 'STDR',
  View = 'STDV',
  Create = 'STDC',
  Modify = 'STDM',
  Delete = 'STDD'
}

export enum DocumentsPermissionMask {
  SiteDocumentRequest = 1,
  View = 2,
  Create = 4,
  Modify = 8,
  Delete = 16
}

export enum SpaceDashboardFeaturePermission {
  View = 'SPDV'
}

export enum SpaceDasBoardPermissionMask {
  View = 1
}
